import dayjs, { Dayjs } from "utils/dayjs"
import i18n from "intl/i18n"


import { Guid, IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IAmountWithCurrencyDto } from "./AmountWithCurrency"
import AmountWithCurrency from 'models/AmountWithCurrency';

export enum InvoiceImportItemStatus {
    ready = "ready",
    imported = "imported",
    validating = "validating",
    invalid = "invalid",
    incomplete = "incomplete",
}

export interface IGetInvoiceImportItemDto {
    id: Guid
    status: InvoiceImportItemStatus
    invoiceNumber: string
    invoiceId?: Guid
    requestNumber?: string | null
    requestId?: Guid | null
    ledgerAccount?: string | null
    supplierNumber?: string | null
    invoiceDate?: string
    amount?: IAmountWithCurrencyDto | null
    foreignCurrencyAmount?: IAmountWithCurrencyDto | Partial<IAmountWithCurrencyDto> | null
    referenceNumber?: string | null
    referenceText?: string | null
    invoiceNumberExists?: boolean | null
    invalidFields?: string[]
    isCustomerRequestDeleted: boolean,
    excluded: boolean,
    links?: IApiLink[]
}

export default class InvoiceImportItem {
    id: Guid
    status: InvoiceImportItemStatus
    invoiceNumber: string
    invoiceId?: Guid
    requestNumber?: string
    requestId?: Guid
    ledgerAccount?: string
    supplierNumber?: string
    invoiceDate?: Dayjs
    amount?: AmountWithCurrency
    foreignCurrencyAmount?: AmountWithCurrency | Partial<IAmountWithCurrencyDto>
    referenceNumber?: string
    referenceText?: string
    invoiceNumberExists?: boolean
    invalidFields?: string[]
    isCustomerRequestDeleted: boolean
    excluded: boolean
    linkGetInvoiceDetails?: IApiLink


    sequence?: number

    constructor(dto: IGetInvoiceImportItemDto, sequence?: number) {
        this.id = dto.id
        this.status = dto.status
        this.invoiceNumber = dto.invoiceNumber
        this.invoiceId = dto.invoiceId
        this.requestNumber = dto.requestNumber ?? undefined
        this.requestId = dto.requestId ?? undefined
        this.ledgerAccount = dto.ledgerAccount ?? undefined
        this.supplierNumber = dto.supplierNumber ?? undefined
        this.invoiceDate = dto.invoiceDate ? dayjs.utc(dto.invoiceDate) : undefined
        this.amount = dto.amount ? new AmountWithCurrency(dto.amount) : undefined
        this.referenceNumber = dto.referenceNumber ?? undefined
        this.referenceText = dto.referenceText ?? undefined
        this.invoiceNumberExists = dto.invoiceNumberExists ?? undefined
        this.invalidFields = dto.invalidFields
        this.isCustomerRequestDeleted = dto.isCustomerRequestDeleted
        this.excluded = dto.excluded
        this.linkGetInvoiceDetails = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceDetails && lnk.rel === ApiLinkRel.self)

        if (dto.foreignCurrencyAmount) {
            this.foreignCurrencyAmount = dto.foreignCurrencyAmount.amount && dto.foreignCurrencyAmount.currency ? new AmountWithCurrency(dto.foreignCurrencyAmount as IAmountWithCurrencyDto) : dto.foreignCurrencyAmount
        } else {
            this.foreignCurrencyAmount = undefined
        }

        this.sequence = sequence
    }
}

export function getInvoiceImportItemStatusLabel(status: InvoiceImportItemStatus) {
    switch (status) {
        case InvoiceImportItemStatus.ready:
            return i18n.t("import.readyForImport")
        case InvoiceImportItemStatus.imported:
            return i18n.t("import.imported")
        case InvoiceImportItemStatus.invalid:
            return i18n.t("import.incompleteOrIncorrect")
        case InvoiceImportItemStatus.incomplete:
            return i18n.t("import.importNotComplete")
        default:
            return ""
    }
}
